import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#121212] flex items-center justify-center px-4 relative z-10">
      <div className="w-full max-w-md bg-[#1E1E1E] border border-[#2A2A2A] rounded-2xl p-8 text-center">
        <div className="flex justify-center mb-6"><Logo size={48} /></div>
        <XCircle className="w-14 h-14 text-[#A0A0A0] mx-auto mb-4" />
        <h1 className="font-display font-bold text-2xl uppercase tracking-tight text-white">Checkout cancelled</h1>
        <p className="text-sm text-[#A0A0A0] mt-2 mb-6">No charge was made. You can pick up where you left off anytime.</p>
        <button data-testid="cancel-back-btn" onClick={() => navigate("/discover")} className="w-full py-3 rounded-xl bg-[#FF6B6B] text-black font-bold uppercase tracking-wide text-sm hover:brightness-110 transition-all">Back to Discover</button>
      </div>
    </div>
  );
}
